import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { EnvironmentService } from '../environment/environment.service';
import { ContentPipesByContentType } from './content-pipes.map';

@Injectable()
export class ContentPipeService {
  private acceptedVideoFileGroups = ['videos', 'trailers'];
  private acceptedImageFileGroups = ['images', 'pictures', 'picture', 'posters'];
  imageAssetPath: any;
  videoAssetPath: any;
  constructor(private environmentService: EnvironmentService) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
    this.videoAssetPath = this.environmentService.getVideoAssetPath();
  }

  getDocuments(entry) {
    const documentEntries = [];
    if (!entry || (!entry.dataFiles || !entry.dataFiles.length)) {
      return documentEntries;
    }
    for (const item of entry.dataFiles) {
      const informationDocumentEntry = new Models.InformationDocumentEntry();
      informationDocumentEntry.populateFromJSON({
        title: item.name,
        url: item.url,
        type: 'pdf',
        extension: 'pdf'
      });
      documentEntries.push(informationDocumentEntry);
    }
    return documentEntries;
  }

  getMedia(entry) {
    const mediaEntries: Models.MediaEntry[] = [];
    if (!entry || !entry.mediaFiles) {
      return mediaEntries;
    }
    for (const item of entry.mediaFiles) {
      const fileType = this.acceptedVideoFileGroups.indexOf(item.group) > -1 ? 'video' : 'image';
      const mediaEntry = new Models.MediaEntry();
      const assetsPath = fileType === 'video' ? this.videoAssetPath : this.imageAssetPath;
      mediaEntry.populateFromJSON({
        URL: assetsPath + item.url + '/freeForm',
        type: fileType
      });
      mediaEntries.push(mediaEntry);
    }
    return mediaEntries;
  }

  getTransformedEntry<T extends Models.IbexBaseModel>(entry: any, entrance): T & T[] {
    if (!entry || !entry.type) {
      return null;
    }

    const pipe = ContentPipesByContentType.get(entrance?.config?.overwriteContentType || entrance?.type);

    if (!pipe) {
      return null;
    }
    let data;
    try {
      data = new pipe(this).transform(entry);
    } catch (err) {
      console.warn(err);
    }
    return data;
  }
}
